module.exports = __webpack_public_path__ + "static/st.2-911bb3d00873dceb439985b4fafa49fa.png";